import {createAsyncThunk, createSlice, current} from "@reduxjs/toolkit";
import {deleteRFIDCardApi, extendRFIDCardApi, getRFIDCardApi, postRFIDCardApi} from "../../api/backendAPIs";

export const fetchAllRFIDCard = createAsyncThunk('fetchAllRFIDCard', async () => {
    return await getRFIDCardApi()
})

export const insertNewRFIDCard = createAsyncThunk('insertNewRFIDCard', async (data) => {
    return await postRFIDCardApi(data)
})

export const extendRFIDCard = createAsyncThunk('extendRFIDCard', async (data) => {
    return await extendRFIDCardApi(data)
})

export const deleteRFIDCard = createAsyncThunk('deleteRFIDCard', async (data) => {
    return await deleteRFIDCardApi(data)
})


const initialState = {
    allRFIDCards: [], loadingRFIDCards: false,
}

export const RFIDSlice = createSlice({
    name: 'rfid', initialState, extraReducers: {
        [fetchAllRFIDCard.pending]: (state) => {
            state.loadingRFIDCards = true;
        },
        [fetchAllRFIDCard.fulfilled]: (state, {payload}) => {

            state.allRFIDCards = payload.data.content;
            state.loadingRFIDCards = false;
        },
        [fetchAllRFIDCard.rejected]: (state) => {
            state.loadingRFIDCards = false;
        },
        [insertNewRFIDCard.pending]: (state) => {
            state.loadingRFIDCards = true;
        },
        [insertNewRFIDCard.fulfilled]: (state, {payload}) => {
            let arr = [...current(state.allRFIDCards)]
            arr.push(payload.data)
            state.allRFIDCards = arr
            state.loadingRFIDCards = false;
        },
        [insertNewRFIDCard.rejected]: (state) => {
            state.loadingRFIDCards = false;
        },
        [deleteRFIDCard.pending]: (state) => {
            state.loadingRFIDCards = true;
        },
        [deleteRFIDCard.fulfilled]: (state, action) => {
            // moze i sa payload isto
            let arr = [...current(state.allRFIDCards)]
            let index = arr.findIndex(i => i.cardNumber === action.meta.arg.cardNumber)
            if (index !== -1) {
                arr.splice(index, 1)
                state.allRFIDCards = arr
            }
            state.loadingRFIDCards = false;
        },
        [deleteRFIDCard.rejected]: (state) => {
            state.loadingRFIDCards = false;
        },
        [extendRFIDCard.pending]: (state) => {
            state.loadingRFIDCards = true;
        },
        [extendRFIDCard.fulfilled]: (state, {payload}) => {
            let arr = [...current(state.allRFIDCards)]
            if (payload.data.cardNumber) {
                let index = arr.findIndex(i => i.cardNumber === payload.data.cardNumber)
                if (index !== -1) {
                    arr[index] = payload.data
                    state.allRFIDCards = arr
                }
            }
            state.loadingRFIDCards = false;
        },
        [extendRFIDCard.rejected]: (state) => {
            state.loadingRFIDCards = false;
        }
    }
});

export const RFIDReducer = RFIDSlice.reducer

